export const RewardTokens = {
    mUty: 'mUty',
    xUty: 'xUty',
};
//# sourceMappingURL=reward.js.map